export function UIX_Community(props){

    var val1 = "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege";
    var val2 = "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev";
    var val3 = "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech";
    var val4 = "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org";
    var val5 = "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode";
 
 
    var val1 = "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege";
    var val2 = "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev";
    var val3 = "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech";
    var val4 = "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org";
    var val5 = "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode";
 
 
    var val1 = "https://www.youtube.com/watch?v=ESnrn1kAD4E&ab_channel=ApnaCollege";
    var val2 = "https://www.youtube.com/watch?v=G3e-cpL7ofc&t=1062s&ab_channel=SuperSimpleDev";
    var val3 = "https://www.youtube.com/watch?v=WuiB5TAQOAM&ab_channel=PWSkillsTech";
    var val4 = "https://www.youtube.com/watch?v=OXGznpKZ_sA&ab_channel=freeCodeCamp.org";
    var val5 = "https://www.youtube.com/watch?v=HGTJBPNC-Gw&ab_channel=BroCode";
     
     
     
     
         return (
     
             <>
     
             <h1 className="html_yt_heading">These are the <strong style={{textDecoration : 'underline', color : 'blue'}}>Top 10</strong>  UI_UX_Community Groups That You can Refer  </h1>
     
     
             <h4 className="des_yt_html">
             
                 1. Dive Into The Main Concepts <br/>
                 2. Animation Explanations with real world Examples <br/>
                 3. Important with Note Clarification.
                 </h4>
 
             <h3 style={{textAlign : 'center' }}> Reddits Community Groups </h3>
 
 
 
             {/* <---------------------------------Reddit Community Group------------------------------------------*/}
 
 
             <div className="container_html_yt_links">
     
                 <p className="vid"> 1. UI_UX_Community College
     
                 {/* <strong style={{marginLeft : '40px', marginRight : '40px' ,border: '1px solid black', padding : '9px' , borderRadius: '7px', fontSize : '17px'
                 }}> HTML</strong> 4.7 &#9733; &#9733; &#9733; &#9733;
                 */}
     
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val1, "_blank")}>  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
                 {/* <-----------------------------------------2------------------------------------------*/}
     
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 2.SuperSimpleDev ( Highly Recommended )
     
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val2, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
                 {/*  <-----------------------------------------3------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 3.PW Skills Tech
                      
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val3, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
                 {/*  <-----------------------------------------4------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                      4. SuperSimpleDev 
     
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val4, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
     
             {/*  <-----------------------------------------5------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 5.Bro Code    
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val5, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
             <h3 style={{textAlign : 'center' }}> Discord Groups </h3>
                 {/*  <--------------------------- Discord Groups ------------------------------------------*/}
 
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 1.FreeCodeCamp
                      
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val1, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
                 {/*  <-----------------------------------------7------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 2.Thapa Technical (Recommended) 
                     
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val2, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
                 {/*  <-----------------------------------------8------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 3. Anuj Bhaiya ( TailWind CSS )
                       
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val3, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
     
             { /*  <-----------------------------------------9------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid">
                 4.Apna College ( Recommended ) 
                   
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val4, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
         {/*  <-----------------------------------------10------------------------------------------*/}
             <div className="container_html_yt_links">
     
                 <p className="vid"> 
                 5. Ws Cube Tech (TailWind CSS)  
                    
                 
                 <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val5, "_blank")} >  Click Me </button>  
     
                 </p>
             <p>
                 </p>
     
             </div>
 
 
              {/*  <--------------------------- Linkedin Groups ------------------------------------------*/}
 
              <h3 style={{textAlign : 'center' }}> Linkedin Groups </h3>
 
              <div className="container_html_yt_links">
     
         <p className="vid">
         1.FreeCodeCamp
          
     
     <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val1, "_blank")} >  Click Me </button>  
 
     </p>
     <p>
     </p>
 
     </div>
 
     {/*  <-----------------------------------------7------------------------------------------*/}
     <div className="container_html_yt_links">
 
     <p className="vid">
     2.Thapa Technical (Recommended) 
         
     
     <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val2, "_blank")} >  Click Me </button>  
 
     </p>
     <p>
     </p>
 
     </div>
 
     {/*  <-----------------------------------------8------------------------------------------*/}
     <div className="container_html_yt_links">
 
     <p className="vid">
     3. Anuj Bhaiya ( TailWind CSS )
           
     <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val3, "_blank")} >  Click Me </button>  
 
     </p>
     <p>
     </p>
 
     </div>
 
     { /*  <-----------------------------------------9------------------------------------------*/}
     <div className="container_html_yt_links">
 
     <p className="vid">
     4.Apna College ( Recommended ) 
       
     
     <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val4, "_blank")} >  Click Me </button>  
 
     </p>
     <p>
     </p>
 
     </div>
     {/*  <-----------------------------------------10------------------------------------------*/}
     <div className="container_html_yt_links">
 
     <p className="vid"> 
     5. Ws Cube Tech (TailWind CSS)  
        
     
     <button style={{marginLeft : '200px', padding : '7px' , background : 'black', color:'white' , borderRadius : '8px'}} onClick={() => window.open(val5, "_blank")} >  Click Me </button>  
 
     </p>
     <p>
     </p>
 
     </div>
 
     
             </>
         )
     }
     
     export default UIX_Community;